/**
 * Hides the sticky add-to-cart bar while the footer is on screen, so it never covers the footer.
 * Watches the first footer-group section (the newsletter row) and sets data-ff-footer on <html>.
 */
const footer = document.querySelector('.shopify-section-group-footer-group');
if (footer && 'IntersectionObserver' in window) {
  new IntersectionObserver(([entry]) => {
    document.documentElement.toggleAttribute('data-ff-footer', entry.isIntersecting);
  }).observe(footer);
}
